import { LabelLayer } from "../../../impl/layers/server/LabelLayer";
import { VectorLayer } from "../../../impl/layers/server/VectorLayer";
import { Switchboard } from "../../events";
export class LayerUIFactory {
    constructor() { }
    static construct_ui_for(layer) {
        const cls_string = layer.visible ? 'layer active' : 'layer';
        const ui_parent = $(`<div class="${cls_string}"></div>`);
        const input = LayerUIFactory.construct_input(layer);
        input.on('click', (e) => {
            layer.visible = e.target.checked;
            toggleKmlDownload(layer.visible, $(e.target.parentElement));
            if (layer.is_base) {
                if (!LayerUIFactory.multiBaseLayersEnabled)
                    ui_parent.trigger('base_layer_select', [layer.name, layer.visible]);
                LayerUIFactory.base_layer_change_broadcaster.emit('base_layer_changed', layer);
            }
            ui_parent.toggleClass('active', layer.visible);
        });
        LayerUIFactory.construct_label(layer, input).then(label => ui_parent.append(label));
        if (!layer.is_base) {
            const vertical_ellipses = $(`<span style="cursor:move; float:right; display:none">&#8942;&#8942;</span>`);
            ui_parent.append(vertical_ellipses);
            const placeholder_div = $(`<div id="placeholder_div" style="border:solid 1px #707070; margin:0; border-radius:2px; width:${260}px; height:${28}px; display:none"/>`);
            ui_parent.append(placeholder_div);
        }
        return ui_parent;
        function toggleKmlDownload(visible, parent) {
            if (parent.find(".kml-download-btn").length) {
                parent.find(".kml-download-btn").toggleClass('hidden', !visible);
                parent.find(".kml-download-span").toggleClass('hidden', !visible);
            }
        }
    }
    static async construct_label(layer, input) {
        const element = $(`<label></label>`);
        const name_elem = $(`<span>${layer.name}</span>`);
        const loader = LayerUIFactory.construct_loading_indicator(layer);
        element.append(input);
        element.append(name_elem);
        element.append(loader);
        if (layer.parsing_failed) {
            element.css('cursor', 'not-allowed');
            element.addClass('crossed-out');
            element.attr("title", "Not available");
            element.prop('disabled', true);
        }
        let is_supported_layer = false;
        try {
            if (layer instanceof VectorLayer) {
                is_supported_layer = true;
            }
            else if (layer instanceof LabelLayer) {
                is_supported_layer = await layer.is_kml_download_supported();
            }
        }
        catch (error) {
            console.warn(`Unable to determine KML support for "${layer.name}".`, error);
            is_supported_layer = false;
        }
        if (is_supported_layer && !layer.parsing_failed && LayerUIFactory.kmlDownloadEnabled && !layer.is_base) {
            const btn = $(`<button class='kml-download-btn ${!layer.visible ? 'hidden' : ''}' title="Download KML for ${layer.name} Layer"></button>`);
            const download_img = $(`<i class="fas fa-download"></i>`);
            btn.append(download_img);
            btn.on('click', async (_) => {
                if (layer instanceof VectorLayer) {
                    let vl = layer;
                    await vl.downloadKml();
                }
                else if (layer instanceof LabelLayer) {
                    let ll = layer;
                    await ll.downloadKml();
                }
            });
            const span = $(`<span class='kml-download-span ${!layer.visible ? 'hidden' : ''}'>KML</span>`);
            btn.append(span);
            element.append(btn);
        }
        return element;
    }
    static construct_input(layer) {
        const typ = (!LayerUIFactory.multiBaseLayersEnabled && layer.is_base) ? 'radio' : 'checkbox';
        const name = layer.is_base ? 'baseLayers' : layer.name;
        const element = $(`<input type="${typ}" id="${layer.layer_id}" name="${name}" value="${layer.layer_id}" ${layer.visible ? 'checked' : ''} />`);
        if (layer.parsing_failed) {
            element.prop('disabled', true);
            element.prop('checked', false);
            element.attr("title", "Not available");
        }
        return element;
    }
    static construct_loading_indicator(layer) {
        const loader = $(`<div data-loader-ref="${layer.layer_id}" class="layer_loading_indicator hidden"></div>`);
        return loader;
    }
}
LayerUIFactory.base_layer_change_broadcaster = Switchboard.get_emitter("BASE_LAYER_CHANGED");
LayerUIFactory.multiBaseLayersEnabled = false;
LayerUIFactory.kmlDownloadEnabled = false;
